/**
 * 将本地保存的列配置与当前默认列定义合并，并**保留保存时的列顺序**。
 * 代码里新增的列会追加在末尾（或此前未出现在保存数据中的默认列）。
 *
 * @param {Array<{ prop: string }>} defaultColumns - 当前页面默认列（含新增 prop）
 * @param {Array<{ prop: string }>} savedColumns - localStorage 解析后的数组
 * @returns {Array} 合并后的列配置
 */
export function mergeColumnConfigWithSavedOrder (defaultColumns, savedColumns) {
  const defaults = Array.isArray(defaultColumns) ? defaultColumns : []
  const saved = Array.isArray(savedColumns) ? savedColumns : []
  const defByProp = new Map(defaults.map((c) => [c.prop, c]))
  const merged = []
  const used = new Set()

  for (const sc of saved) {
    const prop = sc?.prop
    if (!prop || used.has(prop)) continue
    const def = defByProp.get(prop)
    if (!def) continue
    // sortable 以代码默认为准（避免本地缓存的 true 覆盖服务端 custom 排序）
    merged.push({ ...def, ...sc, prop: def.prop, sortable: def.sortable })
    used.add(prop)
  }
  for (const def of defaults) {
    if (!used.has(def.prop)) {
      merged.push({ ...def })
      used.add(def.prop)
    }
  }
  return merged
}

/** 若目标键无数据且来源键有数据，则复制（登录后从 guest/anon 继承一份） */
export function copyLocalStorageIfEmpty (toKey, fromKey) {
  if (!toKey || !fromKey || toKey === fromKey) return
  try {
    if (localStorage.getItem(toKey)) return
    const v = localStorage.getItem(fromKey)
    if (v) localStorage.setItem(toKey, v)
  } catch (_) {
    /* quota / private mode */
  }
}
